import { render, staticRenderFns } from "./RoadDetails.vue?vue&type=template&id=3270e3f0"
import script from "./RoadDetails.vue?vue&type=script&lang=js"
export * from "./RoadDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports